<template>
	<div class="options" @mouseleave="bShowMenu = false">
		<div class="icon-slot-wrapper" @click="bShowMenu = !bShowMenu">
			<slot>
				<div class="icon icon-md">more_vert</div>
			</slot>
		</div>

		<transition name="fade-down">
			<ContextMenu class="edit-menu" :options="options" v-if="bShowMenu"/>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'options',

	props: {
		// Options
		options: {
			type: Object | Array,
			required: true
		}
	},

	data() {

		return {
			// Show menu flag
			bShowMenu: false
		}
	}
}
</script>

<style lang="stylus" scoped>
.options
	position relative

	.icon
		padding 0.4em
		border-radius 0

		font-size 1.2em

		cursor pointer

		transition 0.15s ease

		&:hover
			border-radius 50%
			background-color dark
	
	.edit-menu
		position absolute
		top 100%
		right 50%
		z-index 1
</style>